import useFetch from '@hooks/useFetch';
import { components } from '@api/api';

type Response = components['schemas']['ConceptLockerDashboardResult'];

export function useConceptLockerSummary () {
    return useFetch<Response>({
        url: '/api/Search/GetPopup',
    });
}